import _createForOfIteratorHelper from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.split.js";
import useCurrentInstance from "@/hooks/useCurrentInstance"; // import {Swiper,SwiperSlide} from "swiper";

import "swiper/swiper.scss"; // import { Swiper, SwiperSlide } from 'swiper/vue';

import Swiper from "swiper"; // import "swiper/swiper.css";

import { useRouter } from "vue-router";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useStore } from "vuex";
export default defineComponent({
  name: "Index",
  components: {// Swiper,
    // SwiperSlide,
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var baseUrl = process.env.VUE_APP_BASE_URL;
    var router = useRouter();
    var store = useStore();
    var location = ref(0);
    var isshow = ref(true);
    var allid = reactive({});
    var Data = reactive({
      lessonListFlag: true,
      learnlistFlag: true,
      punishmentFlag: true,
      stymoneFlag: true,
      lessonList: [],
      learnlist: [],
      stymone: {
        richText: "",
        title: ""
      },
      stymList: [{
        richText: ""
      }],
      punishment: [{
        richText: ""
      }],
      carouselData: [{
        id: 1,
        imgUrl: "../../assets/img/home/index-1.png",
        content: ""
      }, {
        id: 2,
        imgUrl: "../../assets/img/home/index-1.png"
      }, {
        id: 3,
        imgUrl: "../../assets/img/home/index-1.png"
      }, {
        id: 4,
        imgUrl: "../../assets/img/home/index-1.png"
      }],
      newList: [{
        approveStatus: 0,
        author: "",
        columnId: 6,
        columnName: "",
        content: "",
        createDate: "",
        createUserId: -5,
        draft: 0,
        imgUrl: "",
        likeNum: 0,
        modifyDate: "",
        modifyUserId: 1,
        newsId: 0,
        organizeId: 1,
        releaseTime: "",
        source: "",
        title: "",
        videoUrl: ""
      }],
      tabsData: [{
        label: "规章制度",
        left: "0px",
        isTrue: true,
        columnId: 0,
        imgUrl: ""
      }],
      tabsCurrentIndex: 0,
      carouselHeight: "784px"
    });

    var handleAllClick = function handleAllClick(name) {
      if (document.querySelector(".swiper")) {
        var mySwiper = document.querySelector(".swiper");

        switch (name) {
          case "left":
            mySwiper.swiper.slidePrev();
            break;

          case "right":
            mySwiper.swiper.slideNext();
            break;
        }

        handleSwiperClick(name);
      }
    }; // 点击箭头操作时间


    var handleSwiperClick = function handleSwiperClick(name) {
      if (Data.tabsCurrentIndex <= Data.tabsData.length - 1) {
        switch (name) {
          case "left":
            if (Data.tabsCurrentIndex > 0) {
              swiperClick(Data.tabsData[Data.tabsCurrentIndex - 1], Data.tabsCurrentIndex - 1);
            }

            break;

          case "right":
            swiperClick(Data.tabsData[Data.tabsCurrentIndex + 1], Data.tabsCurrentIndex + 1);
            break;
        }
      }
    }; //跳转更多


    function jumpdetail(val) {
      if (val == -1) {
        //标志在首页的模块-1为综合新闻
        router.push({
          name: "multiColumn",
          query: {
            stair: 3,
            son: 1
          }
        });
      } else {
        //为新闻
        // let num = 0
        // Data.tabsData.forEach((item,index)=>{
        //   if(item.columnId == val){
        //     num = index
        //   }
        // })
        router.push({
          name: "multiColumn",
          query: {
            stair: 2,
            son: 2 + "-" + (location.value + 1)
          }
        });
      }
    } //跳转


    function todetails(val) {
      if (val.createUserId != -5) {
        router.push({
          path: "/details",
          query: {
            newsId: val.newsId,
            interfaceName: "newDetails",
            pass: 0,
            category: 1
          }
        });
      }
    }

    function todeta(val) {
      router.push({
        path: "/details",
        query: {
          newsId: val.newsId,
          interfaceName: "allDetails",
          pass: 0,
          category: 3
        }
      });
    }

    function stripscript(s) {
      var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]");
      var rs = "";

      for (var i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }

      return rs;
    } //轮播图


    function articleList() {
      return _articleList.apply(this, arguments);
    } // interface liso{
    //   columnId: number,
    //     pageIndex: number,
    //     pageSize: number,
    //     draft:number
    // }
    //新闻列表


    function _articleList() {
      _articleList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var lis;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["articleList"]({
                  columnId: 1,
                  pageIndex: 1,
                  pageSize: 10,
                  draft: 1
                });

              case 2:
                lis = _context2.sent;

                if (lis.code == 0) {
                  Data.carouselData = lis.data;
                  Data.carouselData.forEach(function (item) {
                    item.imgUrl = item.imgUrl.split(",")[1];

                    if (item.content) {
                      item.content = item.content.replace(/<(img).*?>/g, "【图片】");
                    }
                  });
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _articleList.apply(this, arguments);
    }

    function newsList(_x) {
      return _newsList.apply(this, arguments);
    }

    function _newsList() {
      _newsList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(val) {
        var lis, names;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["newsList"](val);

              case 2:
                lis = _context3.sent;

                if (lis.code == 0) {
                  if (lis.data) {
                    isshow.value = false;

                    if (lis.data.length == 0) {
                      names = Data.newList[0].columnName;
                      Data.newList = [];
                      Data.newList[0] = {
                        approveStatus: 0,
                        author: "",
                        columnId: 6,
                        columnName: names,
                        content: "",
                        createDate: "",
                        createUserId: -5,
                        draft: 0,
                        imgUrl: "",
                        likeNum: 0,
                        modifyDate: "",
                        modifyUserId: 1,
                        newsId: 0,
                        organizeId: 1,
                        releaseTime: "",
                        source: "",
                        title: "",
                        videoUrl: ""
                      };
                    } else {
                      Data.newList = lis.data;
                    }
                  }
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _newsList.apply(this, arguments);
    }

    var imgUrl = ref("");
    articleList(); //栏目列表

    function columnList() {
      return _columnList.apply(this, arguments);
    } // 首页包含的模块关键字


    function _columnList() {
      _columnList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var lis;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["columnList"]();

              case 2:
                lis = _context4.sent;

                if (lis.code == 0) {
                  lis.data.forEach(function (element, index) {
                    if (index == 0) {
                      element.isTrue = true;
                    } else {
                      element.isTrue = false;
                    }
                  });
                  Data.tabsData = lis.data;
                  imgUrl.value = Data.tabsData[0].imgUrl;
                  newsList({
                    columnId: lis.data[0].columnId,
                    pageIndex: 1,
                    pageSize: 6,
                    draft: 1
                  });
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _columnList.apply(this, arguments);
    }

    var keyword = ['download', 'rules', 'learn', 'lesson'];
    var column = ref(store.state.column.column);

    function modelShow() {
      column.value.forEach(function (item) {
        item.children.forEach(function (el) {
          if (keyword.includes(el.keyword)) {
            switch (el.keyword) {
              case 'download':
                //资料下载
                Data.punishmentFlag = el.flag;
                break;

              case 'rules':
                //规章制度
                Data.stymoneFlag = el.flag;
                break;

              case 'learn':
                //两学一做
                Data.learnlistFlag = el.flag;
                break;

              case 'lesson':
                //三会一课
                Data.lessonListFlag = el.flag;
                break;

              default:
                break;
            }
          }
        });
      });
    }

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              modelShow();
              _context.next = 3;
              return columnList();

            case 3:
              // 监听浏览器窗口改变
              window.addEventListener("resize", function () {
                imgLoad();
              }); // 挂载swiper

              new Swiper(".swiper", {
                autoplay: true,
                slidesPerView: 8,
                slidesPerGroup: 1,
                centeredSlides: false,
                slidesOffsetAfter: 40
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))); // swiper点击事件

    var swiperClick = function swiperClick(item, index) {
      location.value = index;
      imgUrl.value = item.imgUrl;
      Data.newList[0].columnName = item.columnName;
      newsList({
        columnId: item.columnId,
        pageIndex: 1,
        pageSize: 6,
        draft: 1
      });

      var _iterator = _createForOfIteratorHelper(Data.tabsData),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var v = _step.value;
          v.isTrue = false;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      Data.tabsCurrentIndex = index;
      item.isTrue = true;
    }; // 动态更换图片大小


    var MyHome = ref(null);

    var imgLoad = function imgLoad() {
      var height = 0;

      if (MyHome.value && MyHome.value.clientWidth >= 1200) {
        if (MyHome.value.clientWidth) {
          height = 784 * MyHome.value.clientWidth / 1920;
        }
      } else {
        height = 784 * 1200 / 1920;
      }

      Data.carouselHeight = height + "px";
    }; //处分
    // async function punishment() {
    //   const lis = await globalProperties?.$api["punishment"]({
    //     moduleId: 1,
    //     pageIndex: 1,
    //    pageSize: 4,
    //   });
    //   if (lis.code == 0) {
    //    Data.punishment = lis.data.list
    //   }
    // }
    // punishment()
    //规章纪律


    function system() {
      return _system.apply(this, arguments);
    }

    function _system() {
      _system = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var lis;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["system"]({
                  moduleId: 2,
                  pageIndex: 1,
                  pageSize: 5
                });

              case 2:
                lis = _context5.sent;

                if (lis.code == 0) {
                  if (lis.data) {
                    Data.stymone = lis.data.shift();
                  }

                  Data.stymList = lis.data;

                  if (lis.data.length != 0) {
                    Data.stymone.richText = Data !== null && Data !== void 0 && Data.stymone ? Data.stymone.richText.replace(/<(img).*?>/g, "【图片】") : "";
                  }
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _system.apply(this, arguments);
    }

    system(); //两学

    function learn() {
      return _learn.apply(this, arguments);
    }

    function _learn() {
      _learn = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var lis;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["learn"]({
                  moduleId: 3,
                  pageIndex: 1,
                  pageSize: 5
                });

              case 2:
                lis = _context6.sent;

                if (lis.code == 0) {
                  Data.learnlist = lis.data;
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _learn.apply(this, arguments);
    }

    learn(); //三会一课

    function lessonList() {
      return _lessonList.apply(this, arguments);
    }

    function _lessonList() {
      _lessonList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var lis;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["lessonList"]({
                  moduleId: 4,
                  pageIndex: 1,
                  pageSize: 5
                });

              case 2:
                lis = _context7.sent;

                if (lis.code == 0) {
                  Data.lessonList = lis.data;
                }

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return _lessonList.apply(this, arguments);
    }

    lessonList(); //需要下载附件列表

    function downloadDetails() {
      return _downloadDetails.apply(this, arguments);
    }

    function _downloadDetails() {
      _downloadDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var lis;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["downloadDetails"]({
                  moduleId: 6,
                  pageIndex: 1,
                  pageSize: 10
                });

              case 2:
                lis = _context8.sent;

                if (lis.code == 0) {
                  Data.punishment = lis.data;
                  Data.punishment.forEach(function (item) {
                    item.richText = item.richText.replace(/<(img).*?>/g, "【图片】");
                  }); //  let str =  Data.punishment[0].richText.replace(/src="(\.\.\/)*(\w+\/)+\w+\.(bmp|jpg|png|tif|gif|pcx|tga|exif|fpx|svg|psd|cdr|pcd|dxf|ufo|eps|ai|raw|WMF|webp|jpeg)/gi,"【图片】")
                }

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
      return _downloadDetails.apply(this, arguments);
    }

    downloadDetails();
    return {
      allid: allid,
      isshow: isshow,
      Data: Data,
      MyHome: MyHome,
      imgLoad: imgLoad,
      swiperClick: swiperClick,
      articleList: articleList,
      columnList: columnList,
      newsList: newsList,
      // punishment,
      system: system,
      learn: learn,
      lessonList: lessonList,
      todetails: todetails,
      todeta: todeta,
      downloadDetails: downloadDetails,
      jumpdetail: jumpdetail,
      imgUrl: imgUrl,
      location: location,
      baseUrl: baseUrl,
      handleAllClick: handleAllClick,
      handleSwiperClick: handleSwiperClick
    };
  }
});